import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isOpen: false,
  copied: false,
};

const shareModalSlice = createSlice({
  name: "shareModal",
  initialState,
  reducers: {
    openModal: (state, action) => {
      state.isOpen = true;
    },
    closeModal: (state, action) => {
      state.isOpen = false;
      state.copied = false;
    },
  },
});

export const { openModal, closeModal } = shareModalSlice.actions;

export default shareModalSlice.reducer;
